/* File names in src/content/articles and what they mean.
     my-article.ts          published, at /articles/my-article
     my-article.draft.ts    draft: reachable at its address, listed nowhere
     _anything.ts           not an article (types, the text of the index page)
   Kept apart from articles.ts so the header can ask "is there anything
   published?" from the file names alone, without loading the articles. */
const FILE = /([^/]+?)(\.draft)?\.ts$/;

export function readArticleFile(path: string) {
  const match = path.match(FILE);
  if (!match || match[1].startsWith("_")) return null;
  return { slug: match[1], draft: Boolean(match[2]) };
}

// Lazy: only the file names are used here, nothing is loaded.
const files = import.meta.glob(["../content/articles/*.ts", "!../content/articles/_*.ts"]);

/** Slugs of the published articles. A page that links to an article asks here first, so the link only shows once the article is out. */
export const publishedSlugs = new Set(
  Object.keys(files)
    .map(readArticleFile)
    .filter((file) => file !== null && !file.draft)
    .map((file) => file!.slug),
);

/** True once at least one article is published. The "Articles" link in the header waits for it. */
export const hasPublishedArticles = publishedSlugs.size > 0;
